import clientP from "./client/portalClient";
import clientS from "./client/sToolClient";

const getProducts = (search) => clientP.get(`/search/products?q=${search}`)
const getNaw = (search) => clientP.get(`/search/naw?q=${search}`)
const getProject = (id) => clientS.get(`/service/${id}`)
const putProject = (id, data) => clientS.put(`/service/${id}`,data)

const getUsersByRole = (role) => clientP.get(`/users?role=${role}`);
const sendFinanceInfo = (id, data) => clientP.put(`/sales_offers/${id}/finance`, data);

const portalApi = {
    getProducts,
    getNaw,
    getProject,
    putProject,
    getUsersByRole,
    sendFinanceInfo
}
export default portalApi
